import getTacticalOffers from '../../integration/tacticalOffers.api';

const getTacticalOffer = async (graphql, serviceGroupCode) => {
  try {
    const variables = {
      serviceGroupCode,
    };
    const tacticalOffersData = await getTacticalOffers({ graphql, variables });
    //   return formatAddOnsData(addOnsData);
    return tacticalOffersData;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export default getTacticalOffer;
